
// --- Browser Details --- //
function getBroswerDetails() {
  //Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
    document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
    document.querySelector("html").classList.add("mac");
  } else {
    document.querySelector("html").classList.add("windows");
  }
  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
    document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
    document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
    document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
    document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
    document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
    document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
    document.querySelector("html").classList.add("isEdgeChromium")
  } else {
    document.querySelector("html").classList.add("isBlink")
  }
}
getBroswerDetails();



const menubaar = document.querySelector('.header__icon--menu');
const megamenu = document.querySelector(".megamenu_main_wrapper");
menubaar.addEventListener('click', (e) => {
  megamenu.classList.toggle("active");
  menubaar.classList.toggle("active");
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function cartPopupPos() {
  var cartPopup = document.querySelector('.cart-popup');
  var headerIconCart = document.querySelector('.header__icon--cart');

  if (cartPopup && window.innerWidth >= 768) {
      var l = headerIconCart.offsetLeft - cartPopup.offsetWidth + 20;
      var t = document.querySelector('header').offsetHeight;

      cartPopup.style.left = l + 'px';
      cartPopup.style.top = t + 'px';
  }
}

cartPopupPos();

// Subscription Icon
if (document.querySelector(".subscription-slider")) {
  var subscriptionSlider = new Flickity(".subscription-slider", {
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
      contain: true
  });
}

// Update Subscription Details
function subscribeFooter(totalQuantity, original, price, saving) {
  var inCart = 0;
  var inCartTotal = 0;
  var inCartSavings = 0;
  document.querySelector('.subscription_add').disabled = true;

  fetch("{{ shop.secure_url }}/cart?view=subscription-count")
    .then(response => response.text())
    .then(res => {
      document.querySelector('.subscription_add').disabled = false;
      var ajaxObj = res.split('-');
      inCart = parseInt(ajaxObj[0]);
      inCartTotal = parseInt(ajaxObj[1]);
      inCartSavings = parseInt(ajaxObj[2]);
      var qRemainingClean = 3 - totalQuantity;

      if (price < 1) {
        price = price + inCartTotal;
      }
      if (saving < 1) {
        saving = saving + inCartSavings;
      }
      if (original < 1) {
        original = original + (price + saving);
      }
      if (totalQuantity < 1) {
        totalQuantity = totalQuantity + inCart;
      }

      document.querySelector('[data-total-quantity]').setAttribute('data-total-quantity', totalQuantity);
      document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-footer-atc .contents span').innerText = totalQuantity;

      var qRemainingClean = 3 - totalQuantity;

      var itemRemaining;
      var qRemaining = 3 - totalQuantity;
      var subscribeError = document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-tools .subscribe-error span');
      var subscribeBar = document.getElementById('shopify-section-subscription-collection').querySelector('.mob-fix .subscribe-error span');

      if(qRemainingClean == 3){
        document.querySelector('.add-to-basket').classList.add('disabled');
      }else{
        document.querySelector('.add-to-basket').classList.remove('disabled');
      }
      if(qRemaining == 3){
        itemRemaining = 'three';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else if(qRemaining == 2){
        itemRemaining = 'two';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else if(qRemaining == 1){
        itemRemaining = 'one';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      }else{
        subscribeError.parentElement.parentElement.classList.add('error-hide');
        subscribeError.parentElement.style.display = 'none';
        subscribeError.parentElement.previousElementSibling.style.display = 'none';
        subscribeBar.parentElement.classList.add("success");
      }
      subscribeBar.innerText = itemRemaining;
      subscribeError.innerText = itemRemaining;

      document.querySelector('.subscribe-footer-steps .subs-number.active').classList.remove('active');
      var subsNumbers = document.querySelectorAll('.subscribe-footer-steps .subs-number');
      for (var i = 0; i < totalQuantity; i++) {
        subsNumbers[i].classList.add('active');
      }

      document.querySelector('.subscribe-footer-totals .subtotal .money').setAttribute('data-amount', original);
      document.querySelector('.subscribe-footer-totals .subtotal .money').innerText = Shopify.formatMoney(original, document.body.getAttribute('data-format'));

      document.querySelector('.subscribe-footer-totals .saving .money').setAttribute('data-amount', saving);
      document.querySelector('.subscribe-footer-totals .saving .money').innerText = '-' + Shopify.formatMoney(saving, document.body.getAttribute('data-format'));

      if (price > 0) {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.add('show');
      } else {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.remove('show');
      }

      document.querySelector('.subscribe-footer-totals .total .money').setAttribute('data-amount', price);
      document.querySelector('.subscribe-footer-totals .total .money').innerText = Shopify.formatMoney(price, document.body.getAttribute('data-format'));
    })
    .catch(error => console.error('Error:', error));
}

// Add to basket click
if(document.getElementById('shopify-section-subscription-collection')){
  document.getElementById('shopify-section-subscription-collection').querySelector('.add-to-basket').addEventListener('click', function() {
    this.classList.add('disabled');
    var defaultLabel = this.querySelector('.button-label').innerText;
    this.querySelector('.button-label').innerText = 'adding...';
    
    var product_array = [];
    document.querySelectorAll('.subscription_product.selected').forEach(function(element) {
        var variantID = element.getAttribute('data-variant');
        var variantQuantity = element.querySelector('.product-quantity__input').value;
        var variantComparePrice = element.querySelector('[data-compare-price]').getAttribute('data-compare-price');
        var item = {
            "variantID": variantID,
            "variantQuantity": variantQuantity,
            "variantComparePrice": variantComparePrice
            // "sellingPlan": sellingPlan
        };
        product_array.push(item);
    });

    document.querySelector('.loading-overlay').classList.add('visible');
    addAllItems(product_array);
  });
}

// Add all items
window.addAllItems = function addAllItems(array) {
    Shopify.queue = [];
    var totalQuantity = 0;
    let quantity = 0;

    if (isNaN(quantity)) {
        quantity = 0;
    }
  
    if (isNaN(totalQuantity)) {
        totalQuantity = 0;
    }
    array.forEach(data => {
        if (data.type === 'one') {
            Shopify.queue.push({
                variantId: data.variantID,
                variantQuantity: data.variantQuantity,
                type: 'one'
            });
        } else {
            Shopify.queue.push({
                variantId: data.variantID,
                variantQuantity: data.variantQuantity,
                selling_plan: data.sellingplanid,
                property: data.property
                // frequency: data.frequency,
                // unit_type: data.unit_type,
                // compare_price: data.variantComparePrice
            });
        }
    });
    Shopify.moveAlong = function () {

        if (Shopify.queue.length) {
            const request = Shopify.queue.shift();
            // totalQuantity += parseInt(request.variantQuantity);

            let data;
            // console.log(request.type);
            if (request.type === 'one') { //console.log("IF loop ID")
                data = {
                    id: request.variantId,
                    quantity: request.variantQuantity
                };
            } else { //console.log("else selling ID",request)
                data = {
                    id: request.variantId,
                    quantity: request.variantQuantity,
                    selling_plan: request.selling_plan,
                    properties: {
                      __free_gift: request.property
                    }
                    // properties: {
                    //   shipping_interval_frequency: request.frequency,
                    //   shipping_interval_unit_type: request.unit_type,
                    //   _compare_price: request.compare_price
                    // }
                };
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then((res) => {
                    Shopify.moveAlong();
                    quantity += parseInt(request.variantQuantity);
                })
                .catch(() => {
                    if (Shopify.queue.length) {
                        Shopify.moveAlong();
                    }
                });
        } else {
            defaultCartDrawerUpdate();
            // addToCartOk(totalQuantity);
            cartUpdate('basic');
            // resetExpandWidget();
            resetPage();
        }
    }
    Shopify.moveAlong();
}

async function defaultCartDrawerUpdate() {
  try {
    const response = await fetch(`${Shopify.routes.root}cart?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const selector = ['cart-drawer'];
    const targetElement = document.querySelector(selector);
    const sourceElement = html.querySelector(selector);
    const isCartEmpty = sourceElement.classList.contains("is-empty");
    isCartEmpty ? targetElement.classList.add("is-empty") : targetElement.classList.remove("is-empty")
    targetElement.innerHTML = sourceElement.innerHTML;
    const res = await fetch(`${Shopify.routes.root}cart?section_id=cart-icon-bubble`);
    const resText = await res.text();
    const icon_bubble_html = new DOMParser().parseFromString(resText, 'text/html');
    const selector_bubble = ['#cart-icon-bubble'];
    const targetElement_bubble = document.querySelector(selector_bubble);
    const sourceElement_bubble = icon_bubble_html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;
    
    if (targetElement_bubble && sourceElement_bubble) {
      targetElement_bubble.innerHTML = sourceElement_bubble;
    }
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    document.querySelector('#cart-icon-bubble').click();
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}

window.addEventListener("quizifyAddToCart", function(){
    defaultCartDrawerUpdate();
})

// After all items added
function addToCartOk(quantity) {
    // const addToBasketButton = document.querySelector('#shopify-section-subscription-collection .add-to-basket');
    // const buttonLabel = addToBasketButton.querySelector('.button-label');
  
    // buttonLabel.innerText = 'add subscription to basket';
    // addToBasketButton.classList.remove('disabled');
    cartUpdate('basic');
    cartBubble(quantity);
    resetPage();
}

//Cart Bubble
function cartBubble(quantity) {
  if (quantity > 0) {
    const cartCountBubble = document.querySelector('.cart-count-bubble');

    if (!cartCountBubble) {
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      const newCartCountBubble = document.createElement('div');
      newCartCountBubble.classList.add('cart-count-bubble');

      const firstSpan = document.createElement('span');
      firstSpan.setAttribute('aria-hidden', 'true');
      newCartCountBubble.appendChild(firstSpan);

      const secondSpan = document.createElement('span');
      secondSpan.classList.add('visually-hidden');
      newCartCountBubble.appendChild(secondSpan);

      cartIconBubble.appendChild(newCartCountBubble);
    }

    const firstSpan = document.querySelector('.cart-count-bubble span:first-child');
    firstSpan.innerText = quantity;

    const secondSpan = document.querySelector('.cart-count-bubble span:last-child');
    if (quantity > 1) {
      secondSpan.innerText = quantity + " items";
    } else {
      secondSpan.innerText = quantity + " item";
    }
  } else {
    const cartCountBubble = document.querySelector('.cart-count-bubble');
    if (cartCountBubble) {
      cartCountBubble.remove();
    }
  }
}

// Update Slideout Cart
async function cartUpdate(type) {
  const response = await fetch("/cart?view=ajax");
  const data = await response.text();
  
  if (response.ok) {
    document.body.classList.add('cart-open');
    const cartPopupInner = document.querySelector('.cart-popup-inner');
    if(cartPopupInner){      
      cartPopupInner.innerHTML = data;
    }
    const cartPopup = document.querySelector('.cart-popup');
    if(cartPopup){
      cartPopup.classList.add('visible');
    }
  
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const t = currentScrollTop - 1;
    window.scrollTo({ top: t, behavior: 'smooth' });
  
    const loadingOverlay = document.querySelector('.loading-overlay');
    if(loadingOverlay){loadingOverlay.classList.remove('visible');}
  }
}

/*
document.addEventListener('rebuy:cart.change', (event) => {
  const { cart: { cart: Smartcart} } = event.detail;
  setTimeout(()=>{
    const items = Smartcart.items;
    const allLiItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    
    if (items.length > 0) {
      items.forEach((item, index) => {
        if(!allLiItems[index].hasAttribute('lineitem_sellingId')){        
          allLiItems[index]?.setAttribute('lineitem_sellingId', item?.selling_plan_allocation?.selling_plan?.id);
        }
      });
  
      const allQuarterlySubscriptionLi = document.querySelectorAll('[lineitem_sellingid]');
      if (allQuarterlySubscriptionLi.length > 0) {
        allQuarterlySubscriptionLi.forEach(quarterSubscriptionItem => {
          if(quarterSubscriptionItem?.getAttribute('lineitem_sellingid') === '1473806425'){          
            const quantityButtons = quarterSubscriptionItem?.querySelector('.rebuy-cart__flyout-item-quantity-widget')?.querySelectorAll('button');
            if(quantityButtons.length > 0){quantityButtons.forEach(button=> button.classList.add('hidden'))};
          }
        });
      }
    }
    const cartDrawerAnnouncementBar = document.querySelector('.rebuy-cart__flyout-announcement-bar-message');
    if(cartDrawerAnnouncementBar){    
      if(Smartcart.item_count === 0){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.cart_empty;
      } else if(Smartcart.item_count === 1){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.one_product_in_cart;
      } else if(Smartcart.item_count === 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.two_products_in_cart;   
      } else if(Smartcart.item_count > 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.three_products_or_more_in_cart;   
      }
    }
    if(document.querySelector('.cart-count-bubble span:first-child')){
      document.querySelector('.cart-count-bubble span:first-child').innerText = Smartcart.item_count;
    }  
  }, 100);
});
*/


// Reset page after add to basket
function resetPage() {

  const subscriptionLinkButtons = document.querySelectorAll('.subscription-link .subscribe-button');
  subscriptionLinkButtons.forEach(subscriptionLinkButton => {
    if(subscriptionLinkButton.classList.contains('custom-loading')){
      subscriptionLinkButton.classList.remove('custom-loading');
    }
  });

  const productGridForms = document.querySelectorAll('product-grid-form [type="submit"]');
    productGridForms.forEach(productGridForm => {
    if(productGridForm.classList.contains('custom-loading')){
        productGridForm.classList.remove('custom-loading');
    }
  });
  
  const productQuantityElements = document.querySelectorAll('#shopify-section-subscription-collection .product-quantity');
  productQuantityElements.forEach(productQuantityElement => {
    if(productQuantityElement){
      productQuantityElement.classList.remove('show');
    }
  });

  const subscriptionAddElements = document.querySelectorAll('.subscription_add');
  subscriptionAddElements.forEach(subscriptionAddElement => {
    if(subscriptionAddElement){
      subscriptionAddElement.classList.remove('added');
      const amountElement = subscriptionAddElement.querySelector('.amount');
      amountElement.innerText = '';
      const labelElement = subscriptionAddElement.querySelector('.label');
      labelElement.innerText = '&nbsp;add.';
  
      if (subscriptionAddElement.hasAttribute('disabled')) {
        const labelElement = subscriptionAddElement.querySelector('.label');
        labelElement.innerText = '&nbsp;soldout.';
      }
    }
  });

  const subscriptionProductElements = document.querySelectorAll('.subscription_product');
  subscriptionProductElements.forEach(subscriptionProductElement => {
    if(subscriptionProductElement){
      subscriptionProductElement.classList.remove('selected');
      const productQuantityInputElement = subscriptionProductElement.querySelector('.product-quantity__input');
      productQuantityInputElement.value = 1;
    }
  });

  const totalQuantityElement = document.querySelector('[data-total-quantity]');
  if(totalQuantityElement){
    totalQuantityElement.setAttribute('data-total-quantity', 0);
  }

  const subscribeFooterAtcElement = document.querySelector('.subscribe-footer-atc .contents span');
  if(subscribeFooterAtcElement){
    subscribeFooterAtcElement.innerText = '0';
  }

  
}
if (document.querySelector('#subscription-collection')) {
  resetPage();
}
document.addEventListener('click', function(event) {
  if (event.target.matches('.cart-item-remove')) {
    document.querySelector('.loading-overlay').classList.add('visible');
    const t = event.target;
    const updates = {};
    const variantId = t.closest('.cart-popup-item').getAttribute('data-key');
    const removingQuantity = parseInt(t.closest('.cart-popup-item').querySelector('.item-quantity').innerText);
    const quantity = parseInt(document.querySelector('.cart-count-bubble span:first-child').innerText) - removingQuantity;

    updates[variantId] = 0;
    const data = {updates};

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        cartUpdate();
        cartBubble(quantity);

        if (document.querySelector('#subscription-collection')) {
          const variantIDonly = variantId.split(':');
          const newQty = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').getAttribute('data-quantity')) - removingQuantity;
          document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').classList.remove('in-cart').setAttribute('data-quantity', newQty);

          const totalQuantity = parseInt(document.querySelector('[data-total-quantity]').getAttribute('data-total-quantity')) - removingQuantity;
          const line_total_original = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-compare-price]').getAttribute('data-compare-price')) * removingQuantity;
          const original = parseInt(document.querySelector('.subscribe-footer-totals .subtotal .money').getAttribute('data-amount')) - line_total_original;
          const line_total_price = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-price]').getAttribute('data-price')) * removingQuantity;
          const price = parseInt(document.querySelector('.subscribe-footer-totals .total .money').getAttribute('data-amount')) - line_total_price;
          const saving = original - price;
          subscribeFooter(totalQuantity, original, price, saving);
        }
      })
      .catch(error => console.error('Error:', error));
  }
});
  
document.addEventListener('click', function(e) {
  if (e.target.matches('.header__icon--cart')) {
    e.preventDefault();
    if(document.querySelector('.cart-popup')) {
      document.querySelector('.cart-popup').classList.toggle('visible')
    }
    document.body.classList.add('cart-open');
  }
});

window.addEventListener('resize', function() {
  cartPopupPos();
});

// Product Free Gift Logic
async function fetchCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  return responseData;
}

async function handleSubscribeAddToCart({ currentTarget }) { 
  // Add loading class
  currentTarget.classList.add("custom-loading");

  // Fetch latest snapshot of cart
  const cartJson = await fetchCart();

  const itemsArray = [];
  // Get data from attributes
  const variantId = currentTarget.getAttribute("data-variant");
  const sellingPlanId = currentTarget.getAttribute("data-sellingplanid");
  const freeGiftVariantId = currentTarget.getAttribute("data-free-gift-id");
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);
  let quantity = 1;
  if(currentTarget.hasAttribute('custom-quantity')) {
    quantity = parseInt(currentTarget.getAttribute('custom-quantity'));
  }
  const uniqueId = new Date().getTime();
  const mainProductItem = { id: variantId, selling_plan: sellingPlanId, quantity: quantity, properties: {}};
  // console.log(mainProductItem);
  itemsArray.push(mainProductItem);
  if(freeGiftVariantId){    
    if(!cartHasGiftProduct) {
      const freeGiftItem = { id: freeGiftVariantId, quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
      mainProductItem.properties["_custom_free_gift"] = uniqueId;
      itemsArray.push(freeGiftItem);
    }
  }
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: itemsArray}) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
  const data = await response.json();
  currentTarget.classList.remove("custom-loading");
  const closestSubscription = currentTarget.closest('.card_product_subscription');
  // resetExpandWidget();
  defaultCartDrawerUpdate();
}

const productSubscribeButtons = Array.from(document.querySelectorAll(".subscribe-button"));
if(productSubscribeButtons.length) {
  productSubscribeButtons.forEach((productSubscribeButton)=> productSubscribeButton.addEventListener("click", handleSubscribeAddToCart.bind(this), true));
}

// Cart Subscriptions Logic
async function upgradeToQuarterlySubscription({ currentTarget }) {
  const subscriptionCover = currentTarget.closest(".subscription__cover");
  if(!subscriptionCover) return;

  const cartJson = await fetchCart();
  const quantity = subscriptionCover.querySelector('.lineItem_quantity').getAttribute('data-lineitem-quantity');
  const newVariantId = subscriptionCover.querySelector('.lineItem_id').getAttribute('data-lineitem-id');
  const oldVariantId = subscriptionCover.querySelector('.old_lineItem_id').getAttribute('data-old-lineitem-id');
  const newSellingPlan = subscriptionCover.querySelector('.selling_id').getAttribute('data-selling-id');
  
  const freeGiftVariantId = currentTarget.getAttribute('data-free-gift-id');
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);

  // Remove main product
  const updates = { [oldVariantId]: 0 };
  
  // Remove gift item if already exists
  if(freeGiftVariantId){    
    if(cartHasGiftProduct) {
      updates[freeGiftVariantId] = 0;
    }
  }
  
  const updateHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({updates}) };
  const updateCartResponse =  await fetch(`${window.Shopify.routes.root}cart/update.js`, updateHeaders);

  const itemsArray = [];
  
  const uniqueId = new Date().getTime();
  const newItemData = { id: Number(newVariantId), quantity: parseInt(quantity), selling_plan: newSellingPlan, properties: { _custom_free_gift: uniqueId } };
  itemsArray.push(newItemData);
  if(freeGiftVariantId){
    const freeGiftItem = { id: Number(freeGiftVariantId), quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
    itemsArray.push(freeGiftItem);
  }
  
  const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify({ items: itemsArray }) };
  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
  const data = await response.json();
  defaultCartDrawerUpdate();
}

async function upgradeToSubscription({ currentTarget }) {
  const subscriptionCover = currentTarget.closest(".subscription__cover");
  if(!subscriptionCover) return;

  const cartJson = await fetchCart();
  const freeGiftVariantId = currentTarget.getAttribute('data-free-gift-id');
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);
  const uniqueId = new Date().getTime();

  if(!cartHasGiftProduct){    
    if(freeGiftVariantId){
      const freeGiftItem = { id: Number(freeGiftVariantId), quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
      const headers = { method: "POST", headers: {'Content-Type': 'application/json'}, body: JSON.stringify(freeGiftItem) };
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
      const data = await response.json();
    }
  }
  
  const quantity = subscriptionCover.querySelector('.lineItem_quantity').getAttribute('data-lineitem-quantity');
  const variantId = subscriptionCover.querySelector('.lineItem_id').getAttribute('data-lineitem-id');
  const sellingPlanId = subscriptionCover.querySelector('.selling_id').getAttribute('data-selling-id');
  let updates = { 'id': variantId, 'quantity': Number(quantity), 'selling_plan': sellingPlanId, 'properties': { _custom_free_gift: uniqueId } };
  const updateHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) };
  const response =  await fetch(`${window.Shopify.routes.root}cart/change.js`, updateHeaders);
  const data = await response.json();
  defaultCartDrawerUpdate();
}

document.querySelectorAll('product-grid-form form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      submitButton.classList.add('custom-loading');
      const variantID = form.querySelector('[name="id"]').value;
      const productArray = [
        {
          variantID,
          variantQuantity: 1         
        }
      ];
      addAllItems(productArray);
    });
  });

document.addEventListener("DOMContentLoaded", () => {
  const Widget_Main_divs = document.querySelectorAll('.widget_button');
  Widget_Main_divs.forEach(function(widget_div){
    const Collapsible_Buttons = widget_div.querySelectorAll('.collapsible-button');
    Collapsible_Buttons.forEach(function(button){
      button.addEventListener('click', function(el){
        // console.log(button);
        const inputCheck = button.querySelector('.title-label input');
        Collapsible_Buttons.forEach(function(button){
          button.classList.remove('active');
        });
        if(!button.classList.contains('active')){
          button.classList.add('active');
        }
        inputCheck.checked = true;
        
          var Saving_value = '';
          var total_value = '';
          var saving_text = '';
          const Activated_button = widget_div?.querySelector('.collapsible_subscription_main.active');
          const subscription_text_footer = widget_div?.querySelector('.subscription__text_footer');
          const subscription_text_html = Activated_button?.querySelector('.subscription__text')?.innerHTML;
          if(Activated_button){
            Saving_value = Activated_button.getAttribute('data-saving-value');
            total_value = Activated_button.getAttribute('data-total-value');
            saving_text = Activated_button.getAttribute('data-saving-text');
          }
          const collapsible_button_total_wrp = widget_div?.querySelector('.collapsible_button_total_wrp');
          if(collapsible_button_total_wrp){
            const savingEle = collapsible_button_total_wrp.querySelector('.sacing');
            if(savingEle){
              savingEle.querySelectorAll('span')[1].innerText = Saving_value;
            }
            const totalEle = collapsible_button_total_wrp.querySelector('.sacing.total_month_saving');
            if(totalEle){
              totalEle.querySelectorAll('span')[1].innerText = total_value;
              totalEle.querySelectorAll('span')[0].innerText = saving_text;
            }
          }
          if(subscription_text_footer && subscription_text_html){
            subscription_text_footer.innerHTML = subscription_text_html;
          }else{
            if(subscription_text_footer) subscription_text_footer.innerHTML='';
          }
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const AllCollapse_add_buttons = document.querySelectorAll('.collapsible-add-button');
  if(AllCollapse_add_buttons.length > 0){
    AllCollapse_add_buttons.forEach(button=> button.addEventListener('click', triggerRelatedButton.bind(this)));
  }
  
  // const AllCollapse_expand_buttons = document.querySelectorAll('.collapsible-expand-button');
  // if(AllCollapse_expand_buttons.length > 0){
  //   AllCollapse_expand_buttons.forEach(expanded_button=> expanded_button.addEventListener('click', expand_widget.bind(this)));
  // }
});

function resetExpandWidget(){
  const All_card_product_subscriptions = document.querySelectorAll('.card_product_subscription');
  if(All_card_product_subscriptions.length > 0){
    All_card_product_subscriptions.forEach(card_product_subscription=>{
      if(card_product_subscription){
        const nearestLi = card_product_subscription?.closest('li');
        const widget_button = card_product_subscription?.querySelector('.widget_button');
        const collapsible_expand_button = card_product_subscription?.querySelector('.collapsible-expand-button')?.querySelector('button');
        if(collapsible_expand_button && collapsible_expand_button.hasAttribute('hidden')) collapsible_expand_button.removeAttribute('hidden');
        if(widget_button && widget_button.classList.contains('widget-expanded')) widget_button.classList.remove('widget-expanded');
        if(nearestLi && nearestLi.classList.contains('js-widget-expanded')) nearestLi.classList.remove('js-widget-expanded');
      }
    })
  }
}

function expand_widget(event){
  const _this = event.target;
  const nearestLi = _this?.closest('li');
  const nearestEle = _this?.closest('.card_product_subscription');
  if(nearestEle && nearestLi){
    const widgetEle = nearestEle?.querySelector('.widget_button');
    if(nearestLi) nearestLi.classList.add('js-widget-expanded');
    if(widgetEle) widgetEle.classList.add('widget-expanded');
    _this.setAttribute('hidden', true);
  }
}

function triggerRelatedButton(event){  
  const _this = event.target;
  const innerButton = _this.querySelector('button');
  innerButton.classList.add('custom-loading');
  const closestMainEle = _this?.closest('.card_product_subscription');
  const activatedOption = closestMainEle?.querySelector('.collapsible-button.collapsible_subscription_main.active');
  if(activatedOption.classList.contains('collapsible-button__subscription')){
    const subsLink = activatedOption?.querySelector('.subscription-link')?.querySelector('a');
    if(subsLink) subsLink.click();
    const monthlyButton = activatedOption?.querySelector('.subscription-link')?.querySelector('button');
    if(monthlyButton) monthlyButton.click();
    setTimeout(()=>{innerButton.classList.remove('custom-loading')}, 1000);
  }else{
    const oneTimeAddButton = activatedOption?.querySelector('.one-time-add-button');
    if(oneTimeAddButton){
      const ATCbutton = oneTimeAddButton.querySelector('button[name="add"]');
      if(ATCbutton) ATCbutton.click();
      setTimeout(()=>{innerButton.classList.remove('custom-loading')}, 1000);
    }
  }
}


let tabs = document.querySelectorAll('.tab');
let tabContents = document.querySelectorAll('.tabContent');
if(document.getElementById('tabs')){
  document.getElementById('tabs').addEventListener('click', function (event) {
    let target = event.target;
    
    if (target.classList.contains('tab')) {
        tabs.forEach((tab, index) => {
            if (tab === target) {
                hideTabsContent(0);
                tab.classList.add('whiteborder');
                tabContents[index].classList.remove('hide');
                tabContents[index].classList.add('show');
            }
        });
    }
});
}

function hideTabsContent(startIndex) {
    for (let i = startIndex; i < tabContents.length; i++) {
        tabContents[i].classList.remove('show');
        tabContents[i].classList.add('hide');
        tabs[i].classList.remove('whiteborder');
    }
}

function toggleAccordion(sectionId, button) {
    var content = document.getElementById(sectionId);

    if (content.style.height === '0px' || content.style.height === '') {
        content.style.height = content.scrollHeight + 'px';
        button.classList.add("activeButton");
    } else {
        content.style.height = '0px';
        button.classList.remove("activeButton");
    }
  }

document.querySelector(".loginopen-popup").addEventListener("click", function() {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.add('overflow-hidden');
  loginElement.classList.toggle("show");
});

document.querySelector(".closepopup").addEventListener("click", function() {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.remove('overflow-hidden');
  loginElement.classList.remove("show");
});


// Brandbassador/Club functionality 
function openClubPopup(){
  const allTheManualButtons = document.querySelectorAll('.js-brand_bassadorion-custom-button');
  if(allTheManualButtons.length > 0){
    const club_widget_ele = document.querySelector('.js-club-widget-ele')?.querySelector('button');
    allTheManualButtons.forEach(button=>{
      if(club_widget_ele){
        clearTimeout(setTimeoutOnele);
        button.addEventListener('click',()=>{
          club_widget_ele.click();
        })
      }
    })
  }
}

const setTimeoutOnele = setTimeout(openClubPopup, 300);

if(document.getElementById("countdown")){
  if(document.querySelector('.countdown_main').getAttribute('date-reset') == "everyday"){
    // Update the countdown every 1 second
    var countdownInterval = setInterval(function() {
        // Get the current date and time
        var now = new Date().getTime();
    
        // Calculate the end time for the day (midnight of the next day)
        var endOfDay = new Date();
        endOfDay.setHours(24, 0, 0, 0); // Set the time to midnight of the next day
        var endOfDayTime = endOfDay.getTime();
    
        // Calculate the distance between now and the end time
        var distance = endOfDayTime - now;
    
        // Calculate hours, minutes, and seconds from the distance
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
        // Display the countdown timer
        var timerElement = document.getElementById("countdown");
        timerElement.innerHTML = "<div><div>" + hours + "</div><span>hour(s)</span></div><div><div>" + minutes + "</div><span>minute(s)</span></div><div><div>" + seconds + "</div><span>second(s)</span></div>";
    
        // If the countdown is over (at the end of the day)
        if (distance <= 0) {
            // Clear the countdown interval
            clearInterval(countdownInterval);
            
            // Restart the countdown interval to count down to the next day's end time
            countdownInterval = setInterval(arguments.callee, 1000);
        }
    }, 0);
  } else {
    if(document.querySelector('.countdown_main').getAttribute('date-reset') == "specific_day"){
      // Set the date we're counting down to
      var TimerDate = document.getElementById("countdown").getAttribute("data-timer");
      console.log(TimerDate)
      var countDownDate = new Date(TimerDate).getTime();
      
      // Update the count down every 1 second
      var x = setInterval(function() {
      
        // Get today's date and time
        var now = new Date().getTime();
          
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Output the result in an element with id="countdown"
        if(days > 0) {      
          document.getElementById("countdown").innerHTML ="<div> <div>" + days + "</div><span>day(s)</span></div><div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" +  minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        } else{      
          document.getElementById("countdown").innerHTML ="<div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" +  minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        }
          
        // If the count down is over, write some text 
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").innerHTML = "EXPIRED";
          setTimeout(()=>{document.querySelector('.countdown_sticky').style.display = "none";},500);
          document.body.style.setProperty('--counter-height', '0');
        }else{
          document.querySelector(".countdown_sticky").classList.remove("hidden");
        }
      }, 0);
    }
  }
}

// slick slider
if($('.cs-slider-init').length){
    $('.cs-slider-init').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      centerPadding: '10px',
      dots:true
    });
  }

// new-bundle-product-template image slider
var mySwiper = new Swiper('.bundle-product-media-list-desktop', {
  slidesPerView: 1,
  centeredSlides: true,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true
  }, 
  fadeEffect: {
      crossFade: true
  }
});
var mySwiper_mobile = new Swiper('.bundle-product-media-list-mobile', {
  slidesPerView: 1,
  centeredSlides: true,
  pagination: {
      el: '.swiper-pagination-mobile',
      clickable: true,
      dynamicBullets: true
  }, 
  fadeEffect: {
      crossFade: true
  }
});